<template>
  <label
    ref="label"
    @click="focus"
    @keydown.prevent.enter="$refs.label.click()"
    class="t-switch"
    :class="[
      { 't-switch--disabled': disabled },
    ]"
  >
    <input
      ref="input"
      type="checkbox"
      @click.stop
      v-model="computedValue"
      :disabled="disabled"
      :name="name"
      :value="nativeValue"
    >
    <span class="t-switch__body">
      <span class="t-switch__mark"></span>
    </span>
    <span class="t-switch__label"><slot></slot></span>
  </label>
</template>

<script>
import CheckboxRadioMixin from '../../mixins/CheckboxRadioMixin';
import ValidatableMixin from '../../mixins/ValidatableMixin';

export default {
  name: 't-switch',
  mixins: [CheckboxRadioMixin, ValidatableMixin],
};
</script>
